import { render } from "./Consumption.vue?vue&type=template&id=37f4e6f8"
import script from "./Consumption.vue?vue&type=script&lang=js"
export * from "./Consumption.vue?vue&type=script&lang=js"
script.render = render

export default script